module.exports = __webpack_public_path__ + "media/applicants/checkbox-checked-00747632.png";